import { CircularProgress } from "@mui/material";
import React from "react";

interface GradePopupProps {
  onDismiss: () => void;
  submittingGrade: boolean;
}

const GradePopup: React.FC<GradePopupProps> = ({ onDismiss, submittingGrade }) => {
  if(submittingGrade) {
    return (
      <div style={styles.overlay}>
        <div style={styles.popup}>
          <div style={styles.checkmarkContainer}>
            <CircularProgress size={80} />
            <p style={styles.message}>Submitting grade...</p>
          </div>
          <button style={styles.button} onClick={onDismiss}>
            Dismiss
          </button>
        </div>
      </div>
    );
  }
  return (
    <div style={styles.overlay}>
      <div style={styles.popup}>
        <div style={styles.checkmarkContainer}>
          <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={styles.checkmark}
          >
            <circle cx="40" cy="40" r="36" fill="#4CAF50" />
            <path
              d="M25 40L35 50L55 30"
              stroke="white"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <h2 style={styles.title}>Assignment complete!</h2>
        <p style={styles.message}>
          Your grade has been submitted. You may now close this tab or continue exploring.
        </p>

        <button style={styles.button} onClick={onDismiss}>
          Dismiss
        </button>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  popup: {
    backgroundColor: "white",
    borderRadius: "12px",
    padding: "40px",
    maxWidth: "500px",
    width: "90%",
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
    textAlign: "center",
  },
  checkmarkContainer: {
    marginBottom: "24px",
    display: "flex",
    justifyContent: "center",
  },
  checkmark: {
    animation: "scaleIn 0.3s ease-out",
  },
  title: {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "16px",
    marginTop: 0,
  },
  message: {
    fontSize: "16px",
    color: "#666",
    lineHeight: "1.6",
    marginBottom: "32px",
  },
  button: {
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "8px",
    padding: "12px 32px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background-color 0.2s",
  },
};

export default GradePopup;
